<template>
    <v-app class="pa-6">
        <Header  @menu-toggled="menuIsOpen = $event"/>
        <Sidebar  :menu-is-open="menuIsOpen" />
        <v-main class="content">
            <router-view />
            <Footer  style="display: flex; align-items: end;position: absolute; bottom: 0;"/>
        </v-main>
    </v-app>
</template>

<script>
    import Header from '@/components/Header/Header';
    import Sidebar from '@/components/Sidebar/Sidebar';
    import Footer from "@/components/Footer/Footer";
    // import './Layout.scss';

    export default {
        name: 'Layout',
        components: {Footer, Header, Sidebar },
        data() {
            return {
                menuIsOpen: false,
            }
        },
    };
</script>

<style src="./Layout.scss" lang="scss" />
